import { render, staticRenderFns } from "./SemesterDetailCurrent.vue?vue&type=template&id=577efd03"
import script from "./SemesterDetailCurrent.vue?vue&type=script&lang=js"
export * from "./SemesterDetailCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports